import { tuple } from '../../types';
export var SHAPE_TYPES = tuple('circle', 'square');
//# sourceMappingURL=types.js.map